import { ProgressSpinner } from "primereact/progressspinner";

export default function ProgressWrapper() {
	return (
		<div className="flex-col center align-center" style={{ height: '100vh' }}>
			<ProgressSpinner />
		</div>
	)
}
